var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-card-wrapper"},[_c('div',{staticClass:"content"},[_c('avatar',{attrs:{"src":_vm.profile.avatar}}),_vm._v(" "),_c('div',{staticClass:"basic"},[_c('span',{staticClass:"nick text-ellipsis"},[_vm._v(_vm._s(_vm.profile.nick || _vm.profile.userID))]),_vm._v(" "),_c('span',{staticClass:"iconfont",class:_vm.genderClass})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01e1a97b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/im/profile-card.vue
// module id = null
// module chunks = 